import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Link from '@components/link'
import { Image } from '@components/atoms'
import {
  IconFlag,
  IconMarker,
} from '@components/atoms/icons'
import DateRangeNew from '@components/atoms/date-range-new'
import useStyles from './card-event.styles'

const CardEvent = (props) => {
  const {
    headline,
    image,
    heroImage,
    logo,
    course,
    location,
    startDate,
    endDate,
    showEventCollection,
    eventCategory,
    className,
  } = props
  const styles = useStyles()

  const url = (image && image.url) || (heroImage && heroImage.url) || (logo && logo.url)

  return (
    <Box className={`${styles.root} ${className}`}>
      <Link {...props}>
        <Box className={styles.alignment}>
          <Box className={styles.imageContainer}>
            {url && <Image className={styles.image} src={`${url}?w=300&h=150&fit=fill`} alt={image?.description || headline} />}
            <Box className={styles.tagsRow}>
              <Box className={styles.tagsWrapper}>
                {/* Only shows events tag on pages where there can be multiple categories */}
                {eventCategory && showEventCollection && (
                  <Typography variant="body2" className={styles.tag}>{eventCategory.name}</Typography>
                )}
              </Box>
            </Box>

          </Box>
          <Box className={styles.cardInfo}>
            <Box className={styles.dateRange}>
              <DateRangeNew startDate={startDate} endDate={endDate} />
            </Box>
            <Typography variant="h6" variantMapping={{ h6: 'h3' }} className={styles.headline} aria-hidden="true">{headline}</Typography>
            {course && (
              <div className={styles.field}><IconFlag className={styles.icon} />
                <Typography variant="caption" className={styles.fieldText}>{course}</Typography>
              </div>
            )}
            {location && (
              <div className={styles.field}><IconMarker className={styles.icon} />
                <Typography variant="caption" className={styles.fieldText}>{location}</Typography>
              </div>
            )}
          </Box>
        </Box>
      </Link>
    </Box>
  )
}

CardEvent.propTypes = {
  __typename: PropTypes.string,
  headline: PropTypes.string,
  image: PropTypes.shape({
    description: PropTypes.string,
    url: PropTypes.string,
  }),
  heroImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  logo: PropTypes.shape({
    url: PropTypes.string,
  }),
  slug: PropTypes.string,
  eventCategory: PropTypes.shape({
    __typename: PropTypes.string,
    name: PropTypes.string,
  }),
  showEventCollection: PropTypes.bool,
  className: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  location: PropTypes.string,
  course: PropTypes.string,
}

CardEvent.defaultProps = {
  className: '',
}

export default CardEvent
